module.exports = __webpack_public_path__ + "img/pic_category_03_w768.97ef0d65.png";